const config = {
  apiKey: 'AIzaSyAsoagL-WT-ygUz-OGU02Pl6vaUsFnv19M',
  authDomain: 'pitok-mm.firebaseapp.com',
  databaseURL: 'https://pitok-mm.firebaseio.com',
  projectId: 'pitok-mm',
  storageBucket: 'pitok-mm.appspot.com',
  messagingSenderId: '114903815809',
  appId: '1:114903815809:web:f8ee7d3845192783',
};

export default config;
